"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _marked = require("marked");

var _sprintfJs = require("sprintf-js");

var _i18nStructureParser = require("./v2/i18n-structure-parser");

var _i18nStructureParser2 = _interopRequireDefault(_i18nStructureParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Translator = function () {
  function Translator(phrases) {
    _classCallCheck(this, Translator);

    this.phrases = phrases;
  }

  _createClass(Translator, [{
    key: "t",
    value: function t(key) {
      var string = this._getTranslationString(key);

      // Inject variables when a type specifier is present in string
      if (string.match(/%[bcdieufgosxXj]|%\(.+\)s|%\d\$s/)) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return this._injectVariables(key, string, args);
      }

      return string;
    }
  }, {
    key: "tm",
    value: function tm(key) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var string = this.t.apply(this, [key].concat(args));

      return string === "!BADSPRINTF" ? string : this._convertMarkdownToHtml(string);
    }
  }, {
    key: "_getTranslationString",
    value: function _getTranslationString(key) {
      if (!this.phrases || !this.phrases[key]) {
        return key;
      }

      return this.phrases[key];
    }
  }, {
    key: "_injectVariables",
    value: function _injectVariables(key, string, args) {
      if (args.length === 0) {
        return "!BADSPRINTF";
      }

      // Use vsprintf for array arguments
      if (args.length === 1 && Array.isArray(args[0])) {
        return _sprintfJs.vsprintf.apply(undefined, [string].concat(_toConsumableArray(args)));
      }

      return _sprintfJs.sprintf.apply(undefined, [string].concat(_toConsumableArray(args)));
    }
  }, {
    key: "_convertMarkdownToHtml",
    value: function _convertMarkdownToHtml(string) {
      return (0, _marked.marked)(string);
    }
  }, {
    key: "translateAll",
    value: function translateAll(structure) {
      return (0, _i18nStructureParser2.default)(this, structure);
    }
  }]);

  return Translator;
}();

exports.default = Translator;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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